export default __webpack_public_path__ + "static/media/sticker-el.984c7b84.png";